<template>
  <el-form ref="form" :model="formData" :rules="rules">
    <el-row :gutter="20">
      <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
        <el-form-item :label="$l('form_label_tag_type')||'标签类型'" prop="resTagType">
          <el-select
            size="medium"
            style="width: 100%;"
            v-model="formData.resTagType"
            clearable
            filterable
            :disabled="disabled"
            :placeholder="$l('form_label_tag_type')||'标签类型'"
          >
            <el-option :label="$l('form_option_select_label_common_tag') || '公共标签'" value="C"></el-option>
            <el-option :label="$l('form_option_select_label_private_tag') || '私有标签'" value="P"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
        <el-form-item :label="$l('form_label_tag_name')||'标签名称'" prop="resTagName">
          <el-input v-model="formData.resTagName" clearable size="medium" :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
        <el-form-item :label="$l('form_label_status')||'是否有效'" prop="resTagStatus">
          <el-radio-group
            size="medium"
            style="width: 100%;"
            disabled
            v-model="formData.resTagStatus"
          >
            <el-radio label="Y">{{$l('form_radio_label_status_valid') || '有效'}}</el-radio>
            <el-radio label="N">{{$l('form_radio_label_status_invalid') || '无效'}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :xs="{span: 20}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 12}">
        <el-form-item :label="$l('form_label_tag_owner')||'所属人'" prop="resTagOwnerName">
          <el-input
            disabled
            v-model="formData.resTagOwnerName"
            :placeholder="$l('form_label_tag_owner')||'所属人'"
            clearable
            size="medium"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col>
        <div style="font-size: 14px; color: #606266;">
          <span>Create：{{formData.createByName}} at {{formData.createDate}}</span>
          <el-divider direction="vertical"></el-divider>
          <span>Modify：{{formData.modifyByName}} at {{formData.modifyDate}}</span>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  data() {
    return {
      disabled: false,
      formData: {
        resTagCode: "",
        resTagType: "",
        resTagOwner: "",
        resTagOwnerName: "",
        resTagName: "",
        resTagStatus: "Y",
        createByName: "",
        createDate: "",
        modifyByName: "",
        modifyDate: "",
      },
      rules: {
        resTagType: [
          {
            required: true,
            message: this.$l("form_rule_message_tag_type") || "请选择标签类型",
            trigger: "blur",
          },
        ],
        resTagName: [
          {
            required: true,
            message: this.$l("form_rule_message_tag_name") || "请输入标签名称",
            trigger: "blur",
          },
        ],
        resTagStatus: [
          {
            required: true,
            message: this.$l("form_rule_message_status") || "请选择有效状态",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 加载表单数据（新增，编辑，详情）
    fromLoad(ref, val = "") {
      this.init();
      if (ref !== "add") {
        let param = { resTagCode: val };
        this.$api.detailResearchTagApi(param).then((res) => {
          this.formData = res.body;
        });
        // 控制组件不可编辑
        if (ref === "detail") {
          this.disabled = true;
        }
      }
    },
    // 保存数据
    save() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.saveResearchTagApi(this.formData).then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_save_ok") || "保存成功",
              type: "success",
            });
            // 通知父组件保存成功
            this.$emit("success");
          });
        } else {
          return false;
        }
      });
    },
    // 初始化表单数据
    init() {
      this.disabled = false;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
        this.formData = {
            resTagCode: "",
            resTagType: "",
            resTagOwner: "",
            resTagOwnerName: "",
            resTagName: "",
            resTagStatus: "Y",
            createByName: "",
            createDate: "",
            modifyByName: "",
            modifyDate: ""
        }
      }
    },
  },
};
</script>
